import { Component, inject, input } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { MainHeaderComponent } from '@/main/main-header/main-header.component';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { MobileWrapperComponent } from '@/common/mobile-wrapper/mobile-wrapper.component';
import { OfferBoxMobileHorizontalComponent } from '@/main/offer-boxes/offer-box-mobile-horizontal/offer-box-mobile-horizontal.component';
import { MainService } from '@/main/services/main.service';
import { HORIZONTAL_SWIPER_CONFIG } from '@/main/sections/swiper-sections.config';
import { MainLoaderComponent } from '@/main/main-loader/main-loader';

@Component({
	selector: 'app-main-horizontal',
	templateUrl: './main-horizontal.component.html',
	standalone: true,
	imports: [
		MainHeaderComponent,
		SwiperModule,
		CommonModule,
		PipesModule,
		MobileWrapperComponent,
		OfferBoxMobileHorizontalComponent,
		MainLoaderComponent,
	],
})
export class MainHorizontalComponent {
	readonly query = input.required<string>();
	readonly title = input.required<string>();
	readonly titleSuffix = input.required<string>();

	readonly mainService = inject(MainService);

	readonly offerList$ = this.mainService.fetchOfferListFromQuery$(this.query);

	readonly swiperConfig = HORIZONTAL_SWIPER_CONFIG;
}
